import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth/';
import { AngularFirestore } from '@angular/fire/firestore/';
import { AngularFireStorage } from '@angular/fire/storage';

@Component({
  selector: 'app-user-jumbotron',
  templateUrl: './userjumbotron.component.html',
  styleUrls: ['./userjumbotron.component.scss']
})
export class UserjumbotronComponent implements OnInit {
  loggedInUser: any = {};

  constructor(
    private auth: AngularFireAuth,
    private firestore: AngularFirestore,
    private storage: AngularFireStorage) {
    auth.onAuthStateChanged(async (userInfo) => {
      if (!userInfo) {
      } else {
        firestore.doc(`users/${userInfo.uid}`).get().subscribe((user) => {
          storage.storage.ref(`users/${userInfo.uid}`).listAll()
            .then(data => {
              this.loggedInUser = user.data();
              this.loggedInUser.indeksURLs = [];
              data.items.forEach(async(img)=>{
                let imgUrl = await img.getDownloadURL()
                console.log(imgUrl)
                this.loggedInUser.indeksURLs.push(imgUrl)
              })
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    })
  }

  ngOnInit(): void {
  }

}
